import { render, staticRenderFns } from "./AcceptedTask.vue?vue&type=template&id=22448c00&scoped=true"
import script from "./AcceptedTask.vue?vue&type=script&lang=js"
export * from "./AcceptedTask.vue?vue&type=script&lang=js"
import style0 from "./AcceptedTask.vue?vue&type=style&index=0&id=22448c00&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22448c00",
  null
  
)

export default component.exports